import { useQuery } from '@tanstack/react-query';
import { FlowVersionTarget } from 'flow-schema';

import { api, getQueryProps, isTruthy } from 'common';

interface UseSubflowVersionQueryProps {
  flowId: string | undefined;
  target: FlowVersionTarget | undefined;
  flowDefinitionId?: string;
}

/**
 * Get targeted subflow definition (specific version or published version)
 */
export function useSubflowVersionQuery(props: UseSubflowVersionQueryProps) {
  const { flowId, target, flowDefinitionId } = props;
  return useQuery({
    ...getQueryProps(api.client.Flow, 'findSubflowVersionOrNullForPublished404', {
      flowId: flowId ?? '_INVALID_',
      target,
      flowDefinitionId,
    }),
    enabled: isTruthy(target === FlowVersionTarget.Published ? flowId : flowDefinitionId),
  });
}
